// @flow
import * as React from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';

import { isDevFlagEnabled } from 'common/components/DevFlag';
import Radio from 'common/domain/radio';

import { getCurrentRadio } from '../modules/authentication/session/selectors/sessionSelectors';

type Props = {
  children: Node,
  radio: Radio,
  allowOnlyNotConfigured: boolean
};

function RadioConfiguredComponent({ allowOnlyNotConfigured, radio, children }: Props) {
  const isRadioConfigured = !radio || (allowOnlyNotConfigured === radio.configurationIs('DONE'));
  if (isRadioConfigured) {
    return null;
  }

  return (
    <span>
      {children}
    </span>
  );
}

function mapStateToProps(state: Object) {
  return {
    radio: getCurrentRadio(state),
  };
}

const Component = connect(mapStateToProps)(withTheme(RadioConfiguredComponent));

export default function withFeatureComponent(props: { children: any }) {
  if (!isDevFlagEnabled('RADIO_CONFIGURATION')) {
    return (<span>{props.children}</span>);
  }

  return <Component {...props} />;
}



// WEBPACK FOOTER //
// ./src/statsradio/components/RadioConfiguredComponent.js